
// Description: Clamp a number between a minimum and maximum value.
function clamp(number, min, max) {
    return Math.max(min, Math.min(number, max));
}

module.exports = clamp